import React, { Component } from 'react'

class IcRightArrow extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <g fill="#FFF" fillRule="nonzero">
          <path
            fillOpacity=".2"
            d="M11.916 0C5.346 0 0 5.346 0 11.916s5.346 11.917 11.916 11.917 11.917-5.346 11.917-11.917C23.833 5.346 18.488 0 11.916 0z"
          />
          <path d="M19.1 8.609a1.813 1.813 0 0 0-1.552-1.41C15.77 7 13.968 6.999 12.176 7c-1.793 0-3.594 0-5.373.199a1.812 1.812 0 0 0-1.55 1.41C5.003 9.695 5 10.88 5 12c0 1.119 0 2.305.25 3.391.175.763.8 1.326 1.55 1.41 1.78.199 3.58.2 5.373.199 1.793 0 3.593 0 5.372-.199a1.813 1.813 0 0 0 1.551-1.41c.25-1.086.251-2.272.251-3.39 0-1.12.002-2.306-.248-3.392zm-8.778 5.618V9.482l4.561 2.38-4.56 2.365z" />
        </g>
      </svg>
    )
  }
}

export default IcRightArrow
